import { createContext, useContext } from "react";
import { LocationStatus } from "../../../types/LocationStatus";

interface LocationCardContextValue {
  derivedStatus: LocationStatus;
}

export const LocationCardContext = createContext<LocationCardContextValue | null>(null);

/**
 * Returns the nearest `LocationCard` context.
 * Throws a descriptive error in development if called outside a `<LocationCard>` root.
 */
export function useLocationCardContext(): LocationCardContextValue {
  const ctx = useContext(LocationCardContext);
  if (!ctx) {
    throw new Error(
      "useLocationCardContext: this subcomponent must be rendered inside a <LocationCard>."
    );
  }
  return ctx;
}

